import { bindSearchableSelections } from "../../ui/searchable-selection.ts";

export interface TaskComposerControllerActions {
  input: (form: HTMLFormElement) => void;
  change: (form: HTMLFormElement, target: HTMLInputElement | HTMLSelectElement) => void;
  recurrenceChange: (form: HTMLFormElement) => void;
  renderMarkdown: (value: string) => string;
  closeIcon: string;
}

export function bindTaskComposerController(form: HTMLFormElement, actions: TaskComposerControllerActions): void {
  bindSearchableSelections(form);
  form.addEventListener("invalid", event => {
    for (let parent = (event.target as HTMLElement).parentElement; parent && parent !== form; parent = parent.parentElement) if (parent.tagName === "DETAILS") (parent as HTMLDetailsElement).open = true;
  }, true);
  form.querySelectorAll<HTMLInputElement>("[name=type]").forEach(control => control.addEventListener("change", () => {
    const checklist = form.querySelector<HTMLElement>("[data-role=checklist-fields]");
    if (checklist) checklist.hidden = control.value !== "checklist";
  }));
  form.querySelectorAll<HTMLElement>("[data-recurrence-editor] input, [data-recurrence-editor] select").forEach(control => control.addEventListener("change", () => actions.recurrenceChange(form)));
  form.querySelectorAll<HTMLButtonElement>("[data-markdown-mode]").forEach(button => button.addEventListener("click", () => {
    const editor = button.closest<HTMLElement>(".markdown-editor");
    const preview = editor?.querySelector<HTMLElement>("[data-markdown-preview]");
    const textarea = editor?.querySelector<HTMLTextAreaElement>("textarea");
    if (!editor || !preview || !textarea) return;
    const showingPreview = button.dataset.markdownMode === "preview";
    if (showingPreview) preview.innerHTML = textarea.value ? actions.renderMarkdown(textarea.value) : `<p class="muted">Nothing to preview yet.</p>`;
    textarea.hidden = showingPreview;
    preview.hidden = !showingPreview;
    editor.querySelectorAll<HTMLButtonElement>("[data-markdown-mode]").forEach(tab => {
      const selected = tab === button;
      tab.classList.toggle("is-active", selected);
      tab.setAttribute("aria-selected", String(selected));
    });
    if (!showingPreview) textarea.focus();
  }));
  form.addEventListener("input", () => actions.input(form));
  form.addEventListener("change", event => {
    const target = event.target as Element | null;
    if (target?.matches("input, select")) actions.change(form, target as HTMLInputElement | HTMLSelectElement);
  });
  form.querySelector<HTMLElement>("[data-add-exact-reminder]")?.addEventListener("click", event => {
    const button = event.currentTarget as HTMLElement;
    if (form.querySelectorAll("[name=exactReminderAt]").length >= 7) return;
    button.insertAdjacentHTML("beforebegin", `<div class="exact-reminder-row"><input name="exactReminderAt" type="datetime-local" aria-label="Exact reminder date and time"><button class="icon-button" type="button" data-remove-exact-reminder aria-label="Remove exact reminder">${actions.closeIcon}</button></div>`);
    button.previousElementSibling?.querySelector<HTMLInputElement>("input")?.focus();
    if (form.querySelectorAll("[name=exactReminderAt]").length >= 7) button.setAttribute("disabled", "");
  });
  form.addEventListener("click", event => {
    const button = (event.target as HTMLElement).closest<HTMLElement>("[data-remove-exact-reminder]");
    if (!button) return;
    button.closest(".exact-reminder-row")?.remove();
    form.querySelector<HTMLElement>("[data-add-exact-reminder]")?.removeAttribute("disabled");
    actions.input(form);
  });
}
